let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7bGBj")).then(() => parcelRequire('1Dpmk'));